import { Flex, useColorMode } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import BigText from "../../DSL/BigText/BigText";
import Pane from "../../DSL/Pane/Pane";
import { lightOrDarkMode } from "../../DSL/Theme";
import Typography, { TVariant } from "../../DSL/Typography/Typography";
import LeaderborkStore from "./Leaderbork.store";

const ChainIndicator = observer(({ store }: { store: LeaderborkStore }) => {
  const { colorMode } = useColorMode();
  const isV1 = store.leaderboardChain === "v1";
  const version = isV1 ? "V1" : "V3";
  const network = isV1 ? "Ethereum L1" : "Base L2";

  return (
    <Pane>
      <Flex flexDirection={"column"}>
        <Typography
          variant={TVariant.PresStart10}
          color={lightOrDarkMode(colorMode, "gray.500", "gray.400")}
          mb={3}
          block
        >
          Currently viewing
        </Typography>
        <Flex flexDirection={"column"} overflowWrap={"break-word"} wordBreak={"break-word"} minW={0}>
          <BigText size={"md"}>{version}</BigText>
          <BigText size={"sm"}>{"Pixel Portal Holdings"}</BigText>
        </Flex>
        <Typography
          variant={TVariant.PresStart10}
          color={lightOrDarkMode(colorMode, "gray.500", "gray.400")}
          mt={3}
          block
        >
          on {network}
        </Typography>
      </Flex>
    </Pane>
  );
});

export default ChainIndicator;
